import { GetBetterFunctionalImg } from '../../../../../images';

export default function GetBetterFunctional() {
  
  return (
    <div className="relative h-screen ">
      <div className="h-1/2 lg:h-full w-full pt-16 md:pt-20 lg:pt-0 flex flex-col justify-center text-center  lg:w-1/2 lg:text-left ">
        <div className="z-10 px-4 max-w-2xl mx-auto sm:px-8">
          <h1 className="text-center lg:text-left text-primary text-2xl sm:text-3xl lg:text-4xl font-semibold">
            Get better functional and cosmetic treatments
          </h1>
          <p className="mt-3 text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
            <div className="my-2 mx-auto lg:mx-0 lg:my-4 w-32 border border-primary" />
            <p className="text-center lg:text-left text-gray-500 my-1">
              XiViX selects the most performing 3D Scanners (Intra-Oral, Face
              and CBCT X-ray) and the best biocompatible materials in order to
              optimize our prosthetic process and fit.
            </p>
            <p className="text-center lg:text-left text-gray-500 my-1">
              This not only prevents microleakage, but ensure longevity of the
              tooth, soft tissues, bone and the restoration.
            </p>
          </p>
        </div>
      </div>
      <div className="relative w-full h-full lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full z-0">
        <img
          className="absolute inset-0 w-full h-full object-cover"
          src={GetBetterFunctionalImg}
          alt=""
        />
      </div>
    </div>
  );
}
